import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { IDENTITY_STREAM_ID } from '../../constants';
import { getViewOptions } from './options';
import { createSelector } from 'reselect';
export function isInitialized(state) {
    return streamSelectors.isInitialized(state, IDENTITY_STREAM_ID);
}
export function isLoading(state) {
    return streamSelectors.isFetching(state, IDENTITY_STREAM_ID);
}
export function getList(state) {
    return streamSelectors.getItems(state, IDENTITY_STREAM_ID);
}
const getActiveFolder = createSelector([
    getViewOptions
], (state)=>state.activeFolder);
export const getActiveIdentity = createSelector([
    getActiveFolder,
    getList
], (activeFolder, list)=>{
    return activeFolder !== undefined ? list.find((item)=>(item === null || item === void 0 ? void 0 : item.inboxFolderId) === activeFolder || (item === null || item === void 0 ? void 0 : item.removedFolderId) === activeFolder || (item === null || item === void 0 ? void 0 : item.savedFolderId) === activeFolder) : list[0];
});
export const isGroupIdentitySelected = createSelector([
    getActiveIdentity,
    getList
], (activeIdentity, list)=>activeIdentity && list.length > 0 && activeIdentity.gruser.userId !== list[0].gruser.userId);
export const getActiveFolderType = createSelector([
    getActiveFolder,
    getActiveIdentity
], (folder, identity)=>{
    if (folder && (identity === null || identity === void 0 ? void 0 : identity.savedFolderId) === folder) {
        return 'saved';
    }
    if (folder && (identity === null || identity === void 0 ? void 0 : identity.removedFolderId) === folder) {
        return 'archived';
    }
    return 'inbox';
});

//# sourceMappingURL=identity.js.map